import {
  actionButtonNavigationConfigType,
  ActionButtonOutcomesType,
  defaultNavigationConfig,
} from '../action-button-navigation-config.type';
import { ButtonActionType } from '../common.type';

export const generalNavigationConfigMap: Map<ButtonActionType, actionButtonNavigationConfigType> = new Map([
  [
    ButtonActionType.CLEAR_FORM_STATE_AND_REDIRECT,
    {
      [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
    },
  ],
]);
